// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-menu {
    list-style: none; /* Remove bullet points */
    padding: 0;
    margin: 0;
    background-color: #232223;
    border-radius: 8px; /* Add rounded corners to the popover menu */
    overflow: hidden; /* Ensures that rounded corners are respected */
  }
  
  .popover-menu li {
    padding: 8px 16px;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    border-bottom: 1px solid #444; /* Add a line between each option */
    font-size: 13px; /* Adjust font size */
  }
  
  .popover-menu li:hover {
    background-color: #444; /* Change background color on hover */
    color: #ffcc00; /* Change text color on hover */
  }
  
  .popover-menu li:last-child {
    border-bottom: none; /* Remove border from the last item */
  }
  

`, "",{"version":3,"sources":["webpack://./src/components/UI-comp/Styles/Popover.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB,EAAE,yBAAyB;IAC3C,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,kBAAkB,EAAE,4CAA4C;IAChE,gBAAgB,EAAE,+CAA+C;EACnE;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,uDAAuD;IACvD,6BAA6B,EAAE,mCAAmC;IAClE,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,sBAAsB,EAAE,qCAAqC;IAC7D,cAAc,EAAE,+BAA+B;EACjD;;EAEA;IACE,mBAAmB,EAAE,qCAAqC;EAC5D","sourcesContent":[".popover-menu {\n    list-style: none; /* Remove bullet points */\n    padding: 0;\n    margin: 0;\n    background-color: #232223;\n    border-radius: 8px; /* Add rounded corners to the popover menu */\n    overflow: hidden; /* Ensures that rounded corners are respected */\n  }\n  \n  .popover-menu li {\n    padding: 8px 16px;\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    border-bottom: 1px solid #444; /* Add a line between each option */\n    font-size: 13px; /* Adjust font size */\n  }\n  \n  .popover-menu li:hover {\n    background-color: #444; /* Change background color on hover */\n    color: #ffcc00; /* Change text color on hover */\n  }\n  \n  .popover-menu li:last-child {\n    border-bottom: none; /* Remove border from the last item */\n  }\n  \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
